// extracted by mini-css-extract-plugin
export var content = "_ce-3";
export var list = "_ce-4";
export var settingsContent = "_ce-7";
export var settingsPanel = "_ce-8";
export var state = "_ce-6";
export var triggerBadge = "_ce-2";
export var triggerButton = "_ce-1";
export var triggerShell = "_ce-0";
export var unreadDot = "_ce-5";